module.exports = require("elliptic");